import AvatarComponent from '../../../common-components/AvatarComponent/AvatarComponent';
import verifiedIcon from '../../../../images/discovery/demographics/verified.svg';
import '../styles/similarInfluencers.scss';

export default function SimilarInfluencers({ similarInfluencersData }) {
  if (!similarInfluencersData || similarInfluencersData.length === 0) {
    return null;
  }

  return (
    <div className="demographics-card">
      <h2>Similar Creators</h2>
      <div className="lookalikes-container">
        {similarInfluencersData
          ?.sort((a, b) => {
            const x = a.score;
            const y = b.score;
            return x > y ? -1 : x < y ? 1 : 0;
          })
          ?.slice(0, 15)
          ?.map((influencer) => (
            <InfluencerCard key={influencer.user_id} {...influencer} />
          ))}
      </div>
    </div>
  );
}

const InfluencerCard = ({ picture, username, fullname, url, is_verified, ...props }) => {
  return (
    <div className="lookalikes-card">
      <div className="left-container">
        <AvatarComponent src={picture} alt={fullname || username} size={40} />
      </div>
      <div className="right-container">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <p className="username-text">
            @{username || fullname?.replaceAll(' ', '').toLowerCase()}{' '}
            {is_verified && <img src={verifiedIcon} alt="" />}
          </p>
        </a>
        <p className="name-text">{fullname}</p>
      </div>
    </div>
  );
};
